import banner from '../../../assets/industries/healthcare.svg'

import tick from '../../../assets/industries/tick.webp'


export const bannerData = {
    title1: 'Healthcare Software',
    title2: 'Development Services',
    desc: 'CodeZone provides custom software development services to healthcare companies for improving healthcare services.',
    img: banner,
    btnTitle: 'Hire Software Developers'
}

export const hireData = {
    img: tick,
    title: 'Outsource Healthcare Software',
    points: [
      'Competence in custom on demand app development services',
      'Flexible engagement models',
      'UI/UX optimized development',
      'Instant chat support',
      'Diverse technology stack',
      'Data privacy protection'

    ]
}

export const webDesignData = {
    title1: 'Full Spectrum off',
    title1Span: 'Offshore Healthcare Software Development',
    title2: 'and Development Services',
    cards: [
        {
            title: 'Telehealth Software',
            desc: 'Telehealthcare software development covers a broad range of healthcare software services including, remote patient monitoring, mobile health solutions, real-time healthcare, mHealth apps, and telemedicine software.',
        },
        {
            title: 'Medical Software Solutions',
            desc: 'Custom medical software development services to assist healthcare providers in tracking equipment, healthcare supply chain management, asset management, and medical billing.',
        },
        {
            title: 'Health Insurance Software',
            desc: 'Health insurance software development to provide health insurance companies the flexibility to cover claims processing, benefits administration, and other mission-critical insurance processes.',
        },
        {
            title: 'Health Tracking Apps',
            desc: 'Health Tracking Applications development to let your patients keep track of their health including heart rate and blood pressure measurement, access their medication information, adjust nutrition, and more.',
        },
        {
            title: 'Electronic Health Record Software (EHR)',
            desc: 'EMR/EHR software development to help hospitals and individual healthcare service providers in maximizing clinical productivity by interacting with patients via patient portals and facilitating patients to access electronic medical records.',
        },
    ]
}